export enum FormStates {
  Validate = "Validate",
  Update = "Update",
  PreConfirm = "PreConfirm",
  Confirm = "Confirm",
}
